<div class="modal-header">
    <h5 *ngIf="isConfirm">{{'ADDRESS.CONFIRM_TITLE' | translate }}</h5>
    <h5 *ngIf="isNotFound">{{'ADDRESS.NOTFOUND_TITLE' | translate }}</h5>
</div>
<div class="modal-body">
    <p *ngIf="isConfirm">{{'ADDRESS.CONFIRM_MESSAGE' | translate }}</p>
    <p *ngIf="isNotFound">{{'ADDRESS.NOTFOUND_MESSAGE' | translate }}</p>

    <div *ngIf="isConfirm">
        <form name="addressConfirm" novalidate class="general-form">
            <span class="fw-bold">
                {{'ADDRESS.SUGGEST_LABEL' | translate }}
            </span>
            <div class="form-check mb-4">
                <input 
                    class="form-check-input"
                    type="radio" 
                    name="choice" 
                    id="choiceSuggest" 
                    value="suggest" 
                    [(ngModel)]="choice" />
                <label 
                    for="choiceSuggest"
                    class="form-check-label">
                    {{suggestAddress()}}
                </label>
            </div>
            <span class="fw-bold">
                {{'ADDRESS.ENTERED_LABEL' | translate }}
            </span>
            <div class="form-check">
                <input 
                    type="radio"
                    class="form-check-input"
                    name="choice"
                    id="choiceEnter"
                    value="enter"
                    [(ngModel)]="choice"/>
                <label 
                    for="choiceEnter"
                    class="form-check-label">
                    {{enterAddress()}}
                </label>
            </div>
        </form>
    </div>

    <div *ngIf="isNotFound">
            {{enterAddress()}}
    </div>
</div>
<div class="modal-footer">
    <button *ngIf="isConfirm" type="button" class="btn btn-sm btn-blue" (click)="editAddress()" attr.aria-label="{{'ADDRESS.EDIT_BUTTON' | translate }}">{{'ADDRESS.EDIT_BUTTON' | translate }}</button>
    <button *ngIf="isConfirm" type="button" class="btn btn-sm btn-blue" (click)="continue()" attr.aria-label="{{'ADDRESS.CONTINUE_BUTTON' | translate }}">{{'ADDRESS.CONTINUE_BUTTON' | translate }}</button>

    <button *ngIf="isNotFound" type="button" class="btn btn-sm btn-blue" (click)="continueAnyway()" attr.aria-label="{{'ADDRESS.CONTINUE_BUTTON' | translate }}">{{'ADDRESS.CONTINUE_BUTTON' | translate }}</button>
    <button *ngIf="isNotFound" type="button" class="btn btn-sm btn-blue" (click)="fix()" attr.aria-label="{{'ADDRESS.EDIT_BUTTON' | translate }}">{{'ADDRESS.EDIT_BUTTON' | translate }}</button>
</div>
